import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const ByrdleContext = createContext();

export const useByrdle = () => {
  return useContext(ByrdleContext);
};

export const ByrdleProvider = ({ children }) => {
  const [puzzles, setPuzzles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPuzzles = async () => {
      try {
        const { data: puzzlesData, error: puzzlesError } = await supabase
          .from('byrdle_puzzles')
          .select(`
            date,
            title,
            byrdle_clues (
              id,
              answer,
              hint_1,
              hint_2,
              hint_3,
              slug
            )
          `)
          .order('date', { ascending: false });

        if (puzzlesError) throw puzzlesError;

        if (puzzlesData && puzzlesData.length > 0) {
          const formattedPuzzles = puzzlesData.map(puzzle => {
            const sortedClues = puzzle.byrdle_clues
              ? puzzle.byrdle_clues
                  .map(c => ({
                    ...c
                  }))
              : [];
            
            return {
              date: puzzle.date,
              title: puzzle.title,
              puzzleNumber: puzzle.title.match(/#(\d+)/) ? puzzle.title.match(/#(\d+)/)[1] : null,
              clues: sortedClues
            };
          });
          setPuzzles(formattedPuzzles);
        } else {
           setPuzzles([]);
        }
      } catch (err) {
        console.error('Error fetching Byrdle puzzles:', err);
        setError(err.message);
        setPuzzles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPuzzles();
  }, []);

  const value = {
    puzzles,
    loading,
    error
  };

  return (
    <ByrdleContext.Provider value={value}>
      {children}
    </ByrdleContext.Provider>
  );
};


















